const Artcloud = require('../../artcloud.js');

const Type = require('./Type.jsx');

const RenderedCollateral = require('../../../../../artcloud.collateral/source/RenderedCollateral.jsx');

function observableRepository(url) {
    return {
        _callbacks: {},
        _data: null,
        _pending: false,
        _tempCallbacks: [],
        _url: url,

        addObserverCallback: function (name, callback) {
            this._callbacks[name] = callback;
        },

        addTempObserverCallback: function (callback) {
            this._tempCallbacks.push(callback);
        },

        clear: function () {
            this._data = null;
            this._pending = false;
        },

        current: function () {
            return this._data;
        },

        fetch: function (onError, q) {
            if (!this || this._pending) {
                return;
            }
            this._data = null;
            this._pending = true;

            const component = this;
            Artcloud.data.get(
                this._url,
                q,
                function (d) {
                    component._pending = false;
                    component._data = d;

                    component.notify(d);
                }, onError);
        },

        insert: function (d) {
            if (!this._data) {
                this._data = { Data: [] };
            }
            this._data.Data.push(d);
        },

        notify: function (data) {
            let callback;
            for (let name in this._callbacks) {
                callback = this._callbacks[name];
                if (!callback) {
                    continue;
                }
                callback(data);
            }
            this._tempCallbacks.map(function (callback) {
                if (callback) {
                    callback(data);
                }
            });
            this._tempCallbacks = [];
        },

        removeObserverCallback: function (name) {
            this._callbacks[name] = null;
        },

        replace: function (data, sendNotifications) {
            this._data = data;
            if (sendNotifications != false) {
                this.notify(this._data);
            }
        }
    }
}

const Batch = observableRepository(Artcloud.router.batches.get());
const ExchangeRates = observableRepository(Artcloud.router.settings.currencyRates.get());
const Import = observableRepository(Artcloud.router.imports.get());
const InventoryTypes = observableRepository(Artcloud.router.inventoryTypes.get());
const InvoiceStages = observableRepository(Artcloud.router.invoiceStages.get());
const Locations = observableRepository(Artcloud.router.locations.get());
const Messages = observableRepository(Artcloud.router.messages.get());
const OpportunityStages = observableRepository(Artcloud.router.opportunities.stages.get());
const Signature = observableRepository(Artcloud.router.threads.signatures.me.get());
const Staff = observableRepository(Artcloud.router.staff.get());

const Export = observableRepository(Artcloud.router.exports.get());
Export.Pending = {
    _data: {},

    add: (exportId, type) => Export.Pending._data[exportId] = type,
    clear: () => Export.Pending._data = {},
    get: (exportId) => Export.Pending._data[exportId],
    remove: (exportId) => Export.Pending._data[exportId] = undefined
};
Export.Type = {
    Download: 'Attachment',
    Print: 'Inline'
};

const MailingLists = observableRepository(Artcloud.router.mailingLists.get());
MailingLists.mergeInto = function (data) {
    const _data = data || {};
    const mailingLists = MailingLists.current();
    if (!mailingLists) {
        return _data;
    }
    for (let id in mailingLists) {
        if (!_data[id]) {
            _data[id] = [];
        }
        _data[id] = _data[id].concat(mailingLists[id]);
    }
    return _data;
}

const Notifications = observableRepository(Artcloud.router.notifications.get());
Notifications.fetchGlobal = function (onError) { Notifications.fetch(onError, { limit: 3, status: 1, type: 6 }) };

const Session = observableRepository(Artcloud.router.sessions.get());
Session.getManagerSubscriptionTier = (session) => Session._hasManagerSubscriptionTier(session)
    ? session.Subscriptions.Manager.Tier.Value
    : -1;

Session._hasManagerSubscription = (session) => session && session.Subscriptions && session.Subscriptions.Manager;

Session._hasManagerSubscriptionTier = (session) => Session._hasManagerSubscription(session) && session.Subscriptions.Manager.Tier;

Session.getManagerSubscriptionTierName = (session) => Session._hasManagerSubscriptionTier(session)
    ? session.Subscriptions.Manager.Tier.Name
    : '';

Session.isArtist = (session) => session && session.Type && session.Type.Value == Type.User.Artist;

Session.isArtsyIntegrated = (session) => session && session.Permissions && session.Permissions.IsArtsyIntegrated;

Session.isBeta = (session) => session && session.Permissions && session.Permissions.IsBeta;

Session.isManagerFree = (session) => !Session._hasManagerSubscriptionTier(session) || session.Subscriptions.Manager.Tier.Value == Type.Subscription.Tier.getValue(Type.Subscription.Tier.Free);

Session.isManagerLegacy = (session) => Session._hasManagerSubscription(session) && session.Subscriptions.Manager.Legacy && session.Subscriptions.Manager.Legacy.Value == 1;

Session.isManagerProPlus = (session) => Session.getManagerSubscriptionTier(session) === Type.Subscription.Tier.getValue(Type.Subscription.Tier.ProPlus) || Session.getTrialState(session) === Type.Trial.Trialing;

Session.isTrial = (session) => { const trialState = Session.getTrialState(session); return trialState == Type.Trial.Trialing || trialState == Type.Trial.Expired; }

Session.getTrialState = (session) => {
    let trialState = Type.Trial.None;
    if (session) {
        if (Session.getManagerSubscriptionTier(session) > 0) {
            trialState = session.Subscriptions.Manager.TrialState;
        } else if (Session.getWebsiteSubscriptionTier(session) > 0) {
            trialState = session.Subscriptions.Website.TrialState;
        }
    }
    return trialState;
};

Session.getWebsiteSubscriptionTier = (session) => Session._hasWebsiteSubscriptionTier(session)
    ? session.Subscriptions.Website.Tier.Value
    : -1;

Session._hasWebsiteSubscription = (session) => session && session.Subscriptions && session.Subscriptions.Website;

Session._hasWebsiteSubscriptionTier = (session) => Session._hasWebsiteSubscription(session) && session.Subscriptions.Website.Tier;

Session.isWebsiteFree = (session) => !Session._hasWebsiteSubscriptionTier(session) || session.Subscriptions.Website.Tier.Value == Type.Subscription.Tier.getValue(Type.Subscription.Tier.Free);

Session.isWebsiteLegacy = (session) => Session._hasWebsiteSubscription(session) && session.Subscriptions.Website.Legacy && session.Subscriptions.Website.Legacy.Value == 1;

Session.isWebsiteProPlus = (session) => Session.getWebsiteSubscriptionTier(session) === Type.Subscription.Tier.getValue(Type.Subscription.Tier.ProPlus) || Session.getTrialState(session) === Type.Trial.Trialing;

Session.appendWebsiteTierToRoute = (session, route) => {
    let _route = route;
    if (session && session.Subscriptions.Website && session.Subscriptions.Website.Tier) {
        _route += `?websiteTier=${session.Subscriptions.Website.Tier.Value}`;
    }
    return _route;
}
Session.canOnlySeeOwnedClients = (session) => session && session.Permissions.Staff && session.Permissions.Staff.CanOnlySeeOwnedClients;
Session.canOnlySeeOwnedInvoices = (session) => session && session.Permissions.Staff && session.Permissions.Staff.CanOnlyViewAssociatedInvoices;
Session.canOnlySeeOwnedOpportunities = (session) => session && session.Permissions.Staff && session.Permissions.Staff.CanOnlyViewAssociatedOpportunities;
Session.hasStaff = (session) => session && session.Permissions && session.Permissions.HasStaff;

const Usage = observableRepository(Artcloud.router.billing.usage.get());
Usage.refresh = (session, onError, { callback, product, type } = {}) => {
    const data = {};
    if (session.Subscriptions) {
        if (session.Subscriptions.Manager) {
            if (session.Subscriptions.Manager.Legacy) {
                data.legacy = session.Subscriptions.Manager.Legacy.Value
            }
            if (session.Subscriptions.Manager.Tier) {
                data.tier = session.Subscriptions.Manager.Tier.Value
            }
        }
        if (session.Subscriptions.Campaign && session.Subscriptions.Campaign.Tier) {
            data.campaignTier = session.Subscriptions.Campaign.Tier.Value;
        }
        if (session.Subscriptions.Website && session.Subscriptions.Website.Tier) {
            data.websiteTier = session.Subscriptions.Website.Tier.Value;
        }
    }
    if (type == undefined || !Usage.current()) {
        Usage.fetch(onError, data);
        return;
    }
    Artcloud.data.get(
        Artcloud.router.billing.usage.get(type),
        data,
        (responseData) => {
            let key;
            switch (type) {
                case Type.BillingPermission.Action.CreateClient:
                    key = 'Contacts';
                    break;
                case Type.BillingPermission.Action.SendCampaign:
                    key = 'Emails';
                    break;
                case Type.BillingPermission.Action.CreateInventory:
                    key = 'Inventory';
                    break;
                case Type.BillingPermission.Action.CreateInvoice:
                    key = 'Invoices';
                    break;
                case Type.BillingPermission.Action.OptArtistWebsite:
                    key = 'Artists';
                    break;
                case Type.BillingPermission.Action.OptInventoryWebsite:
                    key = 'Inventory';
                    break;
                default:
                    usage.Warning = responseData.Warning;
                    break;
            }
            const usage = Usage.current();
            switch (product) {
                case Type.Subscription.Product.Website:
                    usage.IsWebsiteSoftGated = responseData.IsWebsiteSoftGated;
                    break;
                default:
                    usage.IsSoftGated = responseData.IsSoftGated;
                    break;
            }
            if (key && usage[product]) {
                usage[product][key] = responseData;
            }
            Usage.replace(usage, true);

            if (callback) {
                callback(usage);
            }
        },
        onError
    );
}

const Collateral = {
    Configs: observableRepository(Artcloud.router.collaterals.configs.get()),
    ExportTypes: {
        Arrivals: 'arrivals',
        ArtistBio: 'bios',
        CertificateOfAuthenticity: 'certificates',
        CertificateOfAuthenticityList: 'certificatesList',
        Consignment: 'consignments',
        ConsignmentReport: 'consignmentReport',
        Invoice: 'invoices',
        Mosaic: 'mosaics',
        MosaicItems: 'mosaicItems',
        Offer: 'offers',
        Pricelist: 'pricelists',
        PricelistItems: 'pricelistItems',
        PurchaseOrder: 'purchaseOrders',
        Tearsheet: 'tearsheets',
        TearsheetList: 'tearsheetList',
        WallTag: 'walltags',
        WallTagItems: 'walltagItems'
    },
    configTypeFromExportType: (exportType) => {
        switch (exportType) {
            case Collateral.ExportTypes.ArtistBio:
                return 6;
            case Collateral.ExportTypes.CertificateOfAuthenticity:
            case Collateral.ExportTypes.CertificateOfAuthenticityList:
                return 5;
            case Collateral.ExportTypes.Consignment:
                return 7;
            case Collateral.ExportTypes.Invoice:
                return 3;
            case Collateral.ExportTypes.Mosaic:
            case Collateral.ExportTypes.MosaicItems:
                return 8;
            case Collateral.ExportTypes.Offer:
                return 4;
            case Collateral.ExportTypes.Pricelist:
            case Collateral.ExportTypes.PricelistItems:
                return 1;
            case Collateral.ExportTypes.PurchaseOrder:
                return 0;
            case Collateral.ExportTypes.Arrivals:
            case Collateral.ExportTypes.Tearsheet:
            case Collateral.ExportTypes.TearsheetList:
                return 2;
        }
    },
    exportTypeFromConfigType: (configType) => {
        switch (configType) {
            case 0:
                return Collateral.ExportTypes.PurchaseOrder;
            case 1:
                return Collateral.ExportTypes.Pricelist;
            case 2:
                return Collateral.ExportTypes.Tearsheet;
            case 3:
                return Collateral.ExportTypes.Invoice;
            case 4:
                return Collateral.ExportTypes.Offer;
            case 5:
                return Collateral.ExportTypes.CertificateOfAuthenticity;
            case 6:
                return Collateral.ExportTypes.ArtistBio;
            case 7:
                return Collateral.ExportTypes.Consignment;
            case 8:
                return Collateral.ExportTypes.Mosaic;
        }
    },
    getUrlData: function (type, ids) {
        let urlData;
        if (!ids || !ids.length) {
            return urlData;
        }
        let _id = ids[0];
        let key;
        switch (type) {
            case Collateral.ExportTypes.ArtistBio:
                key = 'ArtistIds';
                _id = ids;
                break;
            case Collateral.ExportTypes.Consignment:
                key = 'ConsignmentId';
                break;
            case Collateral.ExportTypes.Invoice:
            case Collateral.ExportTypes.Offer:
            case Collateral.ExportTypes.PurchaseOrder:
                key = 'InvoiceId';
                break;
            case Collateral.ExportTypes.CertificateOfAuthenticityList:
            case Collateral.ExportTypes.Mosaic:
            case Collateral.ExportTypes.Pricelist:
            case Collateral.ExportTypes.TearsheetList:
                key = 'QuicklistId';
                break;
            case Collateral.ExportTypes.CertificateOfAuthenticity:
            case Collateral.ExportTypes.MosaicItems:
            case Collateral.ExportTypes.PricelistItems:
            case Collateral.ExportTypes.Tearsheet:
                key = 'EditionIds';
                _id = ids;
                break;
        }
        if (key) {
            urlData = { [key]: _id };
        }
        return urlData;
    }
};
Collateral.Configs.getTypedConfigs = function (type) {
    let configs, defaultConfig;
    if (Collateral.Configs.current()) {
        const _type = Collateral.Configs.normalizeType(type);
        configs = [];
        Collateral.Configs.current().forEach(function (d) {
            if (d.Type != _type) {
                return;
            }
            configs.push(d);
            if (d.IsDefault) {
                defaultConfig = d;
            }
        });
    }
    return { configs, default: defaultConfig };
};
Collateral.Configs.normalizeType = function (type) {
    let _type = type;
    switch (_type) {
        case Collateral.ExportTypes.CertificateOfAuthenticityList:
            _type = Collateral.ExportTypes.CertificateOfAuthenticity;
            break;
        case Collateral.ExportTypes.MosaicItems:
            _type = Collateral.ExportTypes.Mosaic;
            break;
        case Collateral.ExportTypes.PricelistItems:
            _type = Collateral.ExportTypes.Pricelist;
            break;
        case Collateral.ExportTypes.Arrivals:
        case Collateral.ExportTypes.TearsheetList:
            _type = Collateral.ExportTypes.Tearsheet;
            break;
        case Collateral.ExportTypes.WallTagItems:
            _type = Collateral.ExportTypes.WallTag;
            break;
    }
    return _type;
}
Collateral.Configs.replaceConfig = function (config, sendNotifications) {
    const data = Collateral.Configs.current();
    if (!data) {
        return;
    }
    for (let i = 0; i < data.length; i++) {
        if (data[i].id != config.id) {
            continue;
        }
        data.splice(i, 1, config);
        break;
    }
    Collateral.Configs.replace(data, sendNotifications);
}
Collateral.Configs.Types = RenderedCollateral.Types;

const Data = {
    _dirty: {},

    Types: {
        Account: 'admin/accounts',
        Artist: 'artists',
        Audience: 'audiences',
        Blog: 'website/blogs',
        BrandPackage: 'admin/brandPackages',
        Campaign: 'campaigns',
        CampaignDomains: 'settings/campaigns/domains',
        CampaignTemplate: 'settings/campaigns',
        City: 'admin/cities',
        Client: 'clients',
        Collateral: 'settings/collateralStyle',
        Composition: 'website/compositions',
        Consignment: 'consignments',
        Domain: 'website/domains',
        EditionSets: 'editionSets',
        EditionTitles: 'editionTitles',
        EmailTemplate: 'emailTemplates',
        Inventory: 'inventory',
        Invoice: 'invoices',
        Media: 'website/media',
        Message: 'messages',
        NewArrivals: 'newArrivals',
        Opportunity: 'opportunities',
        Pages: 'website/pages',
        PromoCode: 'promoCodes',
        PurchaseOrder: 'purchaseOrders',
        Quicklist: 'quicklists',
        Redirect: 'website/redirects',
        ReleaseNote: 'admin/releaseNotes',
        Representative: 'galleries',
        SecondaryMarkets: 'secondaryMarkets',
        Show: 'shows',
        WebsiteComposition: 'website/compositions',
        WebsiteThemes: 'website/themes'
    },

    isDirty: function (name) {
        return this._dirty[name] != null;
    },

    setClean: function (name) {
        this._dirty[name] = null;
    },

    setDirty: function (name) {
        this._dirty[name] = true;
    }
}

const Font = {
    createFontList: (bodyFont, headerFont, availableFonts) => {
        let _bodyFont = bodyFont;
        let _headerFont = headerFont;
        const fonts = [];
        if (availableFonts) {
            availableFonts.forEach((d) => {
                const type = d.type || d.Type;
                switch (type) {
                    case 'Body':
                        _bodyFont = d;
                        break;
                    case 'Header':
                        _headerFont = d;
                        break;
                    default:
                        const family = d.family || d.Family;
                        fonts.push({ label: family, family, value: `'${family}'`, variants: d.variants || d.Variants })
                        break;
                }
            })
        }
        const additional = [];
        if (_headerFont) {
            const family = _headerFont.family || _headerFont.Family;
            additional.push({ label: family, family, value: `'${family}'`, variants: _headerFont.variants || _headerFont.Variants });
        }
        if (_bodyFont) {
            const family = _bodyFont.family || _bodyFont.Family;
            if (additional.length > 0 && additional[0].family != family) {
                additional.push({ label: family, family, value: `'${family}'`, variants: _bodyFont.variants || _bodyFont.Variants });
            }
        }
        if (additional.length > 0) {
            if (fonts.length > 0) {
                fonts.splice(0, 0, { type: 'separator' })
            }
            fonts.splice(0, 0, ...additional)
        }
        return fonts;
    },

    generateGoogleFontLink: (fontFamilies) => `https://fonts.googleapis.com/css?family=${fontFamilies}`,

    getLegacyFonts: (styleguide) => {
        let bodyFont, headerFont;
        for (let i = 0; i < Type.Font.length; i++) {
            const temp = Type.Font[i];
            if (temp.value == styleguide.HeaderFont) {
                headerFont = { family: temp.label };
            } else if (temp.value == styleguide.BodyFont) {
                bodyFont = { family: temp.label };
            }
            if (bodyFont && headerFont) {
                break;
            }
        }
        return { bodyFont, headerFont };
    }
}

const Media = {
    _sizes: {}, // require('../../../stylus/core/media.json')

    Size: {
        Tiny: 'media-ti',
        Small: 'media-sm',
        Medium: 'media-md',
        Large: 'media-lg'
    },

    configureSizes: function (sizeMap) {
        this._sizes = sizeMap;
    },
    getSize: function (name) {
        let size = this._sizes[name];
        if (!size) {
            return 0;
        }
        size = size.replace('px', '');
        return parseInt(size, 10);
    }
}

const PageKit = {
    _callbacks: {},

    addObserverCallback: (name, callback) => {
        PageKit._callbacks[name] = callback;
    },
    removeObserverCallback: function (name) {
        PageKit._callbacks[name] = null;
    },
    update: (data) => {
        let callback;
        for (let name in PageKit._callbacks) {
            callback = PageKit._callbacks[name];
            if (!callback) {
                continue;
            }
            callback(data);
        }
    }
}

const ScrollOffset = {
    _value: 0,

    get: function () {
        return this._value;
    },

    set: function (value) {
        this._value = value || 0;
    }
}

const Tab = {
    init: function () {
        const sessionStorage = window.sessionStorage;
        $(window).on('unload beforeunload', function () {
            sessionStorage.closedLastTab = '1';
        });
        const tabId = sessionStorage.tabId && sessionStorage.closedLastTab !== '2' ? sessionStorage.tabId : sessionStorage.tabId = (new Date()).getTime()
        sessionStorage.closedLastTab = '2';
        sessionStorage.tabId = tabId;
    },

    cleanUp: function () {
        if (typeof Storage === 'undefined') {
            return;
        }
        const compareTime = (new Date().getTime()) - 43200000; // 12 hours
        const prefix = Artcloud.constants.keys.destination.value + '_';
        for (let key in localStorage) {
            if (!key || !key.startsWith(prefix)) {
                continue;
            }
            const time = key.replace(prefix, '');
            if (!time) {
                continue;
            }
            const date = new Date();
            date.setTime(time);
            if (!date) {
                return;
            }
            if (date.getTime() < compareTime) {
                localStorage.removeItem(key);
            }
        }
    },

    destinationKey: function () {
        const key = Object.assign({}, Artcloud.constants.keys.destination);
        key.value = `${key.value}_${this.id()}`;
        return key;
    },

    id: function () {
        if (!window.sessionStorage.tabId) {
            this.init();
        }
        return window.sessionStorage.tabId;
    }
}

module.exports = {
    Batch,
    Collateral,
    Data,
    ExchangeRates,
    Export,
    Font,
    Import,
    InventoryTypes,
    InvoiceStages,
    Locations,
    MailingLists,
    Media,
    Messages,
    Notifications,
    OpportunityStages,
    PageKit,
    ScrollOffset,
    Session,
    Signature,
    Staff,
    Tab,
    Type,
    Usage
}